module.exports = __webpack_public_path__ + "static/media/sources.45597583.svg";